import { Slide } from "@jelly/lesson";

import { task as task04 } from "../../../../../task/course-03/lesson-09/task-04";

const task: Slide = {
  title: "Which statements are correct?",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task04.id,
        },
      },
    },
  },
};

export default task;
